import { useContext, useState } from "react";
import { ToastContext, ToastTypeEnum } from "context/toastContext";
import dayjs from "dayjs";
import typography from "constants/typography.constants";
import downloadFileWithAuthRetry from "helpers/fetch/downloadFileWithAuthRetry";
import { IOrderInput, RouteEnum } from "../types";

const ROUTE = {
  [RouteEnum.CompetencyMap]: "/competency-map/download-list-xlsx",
  [RouteEnum.Examination]: "/examination/download-list-xlsx",
  [RouteEnum.Trial]: "/trial/download-list-xlsx",
  [RouteEnum.Candidate]: "/company-candidate/download-list-xlsx",
  [RouteEnum.Vacancy]: "/vacancy/download-list-xlsx",
  [RouteEnum.VacancyCandidate]: "/vacancy-company-candidate/download-list-xlsx",
};

const FILE_NAME = {
  [RouteEnum.CompetencyMap]: "Список карт компетенций",
  [RouteEnum.Examination]: "Список тестирований",
  [RouteEnum.Trial]: "Список тестирований",
  [RouteEnum.Candidate]: "Список кандидатов",
  [RouteEnum.Vacancy]: "Список вакансий",
  [RouteEnum.VacancyCandidate]: "Список кандидатов вакансии",
};

interface IGetXlsxListFileParams<OrderInput extends string, FilterInput, AvailableColumn> {
  route: RouteEnum;
  order: IOrderInput<OrderInput> | undefined;
  filter: FilterInput;
  columns: AvailableColumn[];
}

const useGetXlsxList = () => {
  const { addToast } = useContext(ToastContext);
  const [isLoading, setIsLoading] = useState(false);

  const getXlsxListFile = async <OrderInput extends string, FilterInput, AvailableColumn>({
    route,
    columns,
    filter,
    order,
  }: IGetXlsxListFileParams<OrderInput, FilterInput, AvailableColumn>) => {
    if (route) {
      setIsLoading(true);
      const preparedColumns = columns.filter((c) => c !== "action");
      await downloadFileWithAuthRetry({
        url: `${process.env.REACT_APP_API_URL}${ROUTE[route]}`,
        filename: `${FILE_NAME[route]}_${dayjs().format("DD.MM.YYYY")}.xlsx`,
        body: {
          columns: preparedColumns,
          filter: filter || {},
          order: order
            ? {
                field: order.field.replace("_", "."),
                order: order.order,
              }
            : undefined,
        },
        addToast,
      });
      setIsLoading(false);
    } else {
      addToast({ text: typography.errors.pleaseRepeat, type: ToastTypeEnum.ERROR });
    }
  };

  return { getXlsxListFile, isLoading };
};

export default useGetXlsxList;
